import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/dashboard/_base/pedidos/editar/")({
  beforeLoad: () => {
    throw redirect({ to: ".." });
  }
});
